import { InputHTMLAttributes } from "react"

type TextInputProps = {
  label?: string
  error?: string
  obscureText?: boolean
  disabled?: boolean
  value?: string
  textSize?: string
} & Omit<InputHTMLAttributes<HTMLInputElement>, "type">

export const TextInput = ({
  label,
  error,
  obscureText,
  disabled,
  defaultValue,
  textSize = "text-sm",
  ...rest
}: TextInputProps) => {
  const { id } = rest
  return (
    <div className="m-0 w-full p-0">
      {id != null && label != null && (
        <label htmlFor={id} className="mb-1 block text-sm text-itc-black100">
          {label}
        </label>
      )}
      <input
        type={obscureText === true ? "password" : "text"}
        id={id}
        disabled={disabled}
        defaultValue={defaultValue}
        className={`box-border h-11 w-full appearance-none rounded-sm border border-itc-border px-4 ${textSize} placeholder:text-itc-black26 focus:border-itc-green focus:outline-none focus:ring-itc-green`}
        {...rest}
      />
      {error != null && (
        <div className="mt-2">
          <p className="text-sm text-itc-red">{error}</p>
        </div>
      )}
    </div>
  )
}

TextInput.displayName = "TextInput"
